export default {
  titleConfirmTransferPopup: "評価テーブル異動確認",
  btnOk: "実行",
};
